module.exports = __webpack_public_path__ + "img/edit-block-dark.e91df844.svg";